import { render, staticRenderFns } from "./LoginGoogleAuth.vue?vue&type=template&id=bc018944&"
import script from "./LoginGoogleAuth.vue?vue&type=script&lang=js&"
export * from "./LoginGoogleAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports